import React, {useState, useEffect, use, useMemo} from 'react';
import { useNavigate, Link} from 'react-router-dom';
import '../styles/global.css'; // Seu CSS global
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { SwapVert, ThumbUpAlt, ThumbDownOffAlt, Visibility, VisibilityOff, Ballot, BallotOutlined } from '@mui/icons-material';
import MenuAssociados from '../components/MenuAssociados';

function AreaDoAssociado() {
  const navigate = useNavigate();
  const loggedIn = sessionStorage.getItem('loggedIn');
  //era localStorage.getItem('loggedIn') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
  useEffect(() => {

    sessionStorage.selectStatusMensalidade = sessionStorage.selectStatusMensalidade || '99';

      if (loggedIn === false || loggedIn === null || loggedIn === undefined) {
          navigate('/Login');
          window.location.reload();
      }
    }, []);

  const [anoAtual, setAnoAtual] = useState(new Date().getFullYear());
  const [menuAberto, setMenuAberto] = useState(false);
  const associado = parseInt(sessionStorage.getItem('pesAssociado'));
  //era localStorage.getItem('pesAssociado') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
  
  const toggleMenu = () => {
    setMenuAberto(!menuAberto);
  };

  const toggleLogoff = () => {
    localStorage.clear();
    localStorage.setItem('loggedIn', false);
    localStorage.removeItem('user');
    sessionStorage.clear();
    
    navigate('/');
    window.location.reload();
  }

  const [usuario, setUsuario] = useState(JSON.parse(sessionStorage.getItem('userStr'))); 
  const [dataCadastro, setDataCadastro] = useState(usuario.pesCriadoEM.split(' ')[0]);
  const [nomeUsuario, setNomeUsuario] = useState('');
  const [mensalidades, setMensalidades] = useState([]);
  const [isLoadingMOD, setIsLoadingMOD] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectStatus, setSelectStatus] = useState('');

  //array de anos para select
  const [yearsSelect, setYearsSelect] = useState([]);
  // Gerar os anos para o select, começando do ano atual e retrocedendo até 2021
  const years = useMemo(() => {
      const currentYear = new Date().getFullYear();
      const startYear = usuario.pesCriadoEM.split('/')[2].split(' ')[0];//2021;
      const yearsArray = [];
 
      // Adiciona o ano atual e retrocede até 5 anos ou o limite de 2021
      for (let i = 0; i <= 30; i++) {
        const year = currentYear - i;
        if (year >= startYear) {
            yearsArray.push(year);
        } else {
            break; // Para o loop se for menor que 2021
        }
      }
      //console.log("Anos para o select de mensalidades:", yearsArray);
      return yearsArray;
  }, []); // Executa apenas uma vez
  
  // Atualiza o estado do select de anos quando a lista de anos for gerada
  useEffect(() => {
     // Define o ano atual como o primeiro da lista (ano mais recente)
    setYearsSelect(years);
    setAnoAtual(years[0]);
  }, [years]);

  // doados do usuario logado
  useEffect(() => {
    const userStr = sessionStorage.getItem('userStr');
    if (userStr) {
      setUsuario(JSON.parse(userStr));
    }
  }, []);
  // nome do usuario logado
  useEffect(() => {
    setNomeUsuario(sessionStorage.getItem('nomeUsuario') || '');
  }, []);
  // obtem da api as mensalidades do associado
  useEffect(() => {
    //console.log("Iniciando obtenção de mensalidades...");

    const userStr = sessionStorage.getItem('userStr');
    if (userStr) {
      setUsuario(JSON.parse(userStr));
    }
    const usuario = JSON.parse(userStr);
    if (parseInt(usuario.IdPessoa) > 0) {
      //console.log("Obtendo mensalidades para o associado: " + usuario.IdPessoa);
      var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
      setIsLoadingMOD(true);

      const dados = {
        IdPessoa: usuario.IdPessoa,
        mslAno: anoAtual
      };
      //console.log("Dados enviados para a API:", dados);
      axios
      .post(
        process.env.REACT_APP_API_URL + 
        '/routes.php?metodo=obtemMensalidades', 
        dados,
        { headers: {
            "X-Access-Token": token,
            "Content-Type": "application/json; charset=UTF-8"
          } }
      )
      .then(response => {
        //console.log(response.data);
        setMensalidades(response.data);
        setIsLoadingMOD(false);
      })
      .catch((error) => {
        let ret = error.message;
        setIsLoadingMOD(false);
        if (ret.includes("401")) {
            console.log("token inválido!")
        }
        else if (ret.includes("403")) {
            window.location.reload();
        }
      });
    }
    else {
      console.log("IdPessoa inválido: " + usuario.IdPessoa);
    }
  },[]);
  // obtem da api as mensalidades do associado ao mudar o anoAtual
  function carregaMensalidades(ano) {
    // console.log("Iniciando obtenção de mensalidades...");

    const userStr = sessionStorage.getItem('userStr');
    if (userStr) {
      setUsuario(JSON.parse(userStr));
    }
    const usuario = JSON.parse(userStr);
    if (parseInt(usuario.IdPessoa) > 0) {
      // console.log("Obtendo mensalidades para o associado: " + usuario.IdPessoa);
      var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
      setIsLoadingMOD(true);

      const dados = {
        IdPessoa: usuario.IdPessoa,
        mslAno: ano
      };
// console.log("Dados enviados para a API:", dados);
      axios
      .post(
        process.env.REACT_APP_API_URL + 
        '/routes.php?metodo=obtemMensalidades', 
        dados,
        { headers: {
            "X-Access-Token": token,
            "Content-Type": "application/json; charset=UTF-8"
          } }
      )
      .then(response => {
        // console.log(response.data);
        setMensalidades(response.data);
        setIsLoadingMOD(false);
      })
      .catch((error) => {
        let ret = error.message;
        setIsLoadingMOD(false);
        if (ret.includes("401")) {
            console.log("token inválido!")
        }
        else if (ret.includes("403")) {
            window.location.reload();
        }
      });
    }
    else {
      console.log("IdPessoa inválido: " + usuario.IdPessoa);
    }
  }
  function handleSelectAno(event) {
      sessionStorage.selectAnoMensalidades = event.target.value
      setAnoAtual(event.target.value)
      carregaMensalidades(event.target.value);
  }
  function handleExibirRecibo(mensalidade) {
        //console.log(mensalidade);
        sessionStorage.reciboOrigem = "AreaDoAssociado";
        navigate(`/ViewPDF`, { state: { registro: mensalidade } });
    }
  function handleEnviarRecibo(mensalidade) {
      //console.log(mensalidade);
      sessionStorage.reciboOrigem = "AreaDoAssociado";
      navigate(`/EnviarRecibo`, { state: { registro: mensalidade } });
  }

  function handleRetornaMes(mes) {
    switch (mes) {
      case '1':
        return 'Janeiro';
      case '2':
        return 'Fevereiro';
      case '3':
        return 'Março';
      case '4':
        return 'Abril';
      case '5':
        return 'Maio';
      case '6':
        return 'Junho';
      case '7':
        return 'Julho';
      case '8':
        return 'Agosto';
      case '9':
        return 'Setembro';
      case '10':
        return 'Outubro';
      case '11':
        return 'Novembro';
      case '12':
        return 'Dezembro';
      default:
        return mes;
    }
  }

  //salvar log de navegação
  useEffect(() => {
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const log = {
      IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
      logTipo: "Navegação",
      logModulo: "Página Área do Associado",
      logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
      logCriadoEm: new Date().toISOString(),
      logCodigoGUID: crypto.randomUUID()
    };
    axios                    
      .post(process.env.REACT_APP_API_URL 
          + '/routes.php?metodo=novoLog', 
          log, {
              headers: {
                  "X-Access-Token" : tokenAPI,
                  "Content-Type": "application/json; charset=UTF-8"
              }
          }
      )
      .then(response => {
          //console.log(response.data[0].mensagem);
      })
      .catch(error => {
          console.error('Erro ao enviar log:', error);
      });
  }, []);

// console.log(usuario.pesCriadoEM);
// const ano = usuario.pesCriadoEM.split('/')[2].split(' ')[0];
// const cadastro = usuario.pesCriadoEM.split(' ')[0];
// console.log(ano);
// console.log(cadastro);
// console.log(new Date(usuario.pesCriadoEM).getFullYear());

  return (
    <div style={{ paddingBottom: '80px' }}>
      <main>
        <div>
          {/* Menu de navegação */}
          <MenuAssociados />
          {/* Titulos da página */}
          <div className='headerMain'>
            <label className='labelTitulo' >ÁREA DO ASSOCIADO</label>
            <h3>Suas Contribuições Associativas</h3>
            <span style={{fontSize: 14}}>Cadastro/Inicio contribuição: {dataCadastro}</span>
          </div>

          <div className='containerBarraPesquisa'>
            {/* pesquisa por texto no mes e ano */}
            <input className='inputBarraPesquisa' style={{ display: 'none'}}
            placeholder='PESQUISAR'
            type='text'
            id='inputPesquisa'
            name='inputPesquisa'
            onChange={event => {
              setSearchTerm(event.target.value)
            }}
            />
            {/* selects de ano */}
            <select className="selectStatusPesquisa"
                name="selectAnoMensalidade"
                id="selectAnoMensalidade"
                onChange={event => {
                    handleSelectAno(event);
                }}
            >
                {yearsSelect.map((year) => (
                    <option key={year} value={year} selected={parseInt(anoAtual) === year}>{year}</option>
                ))}
                
            </select>
            {/* input select para filtro do mslStatus */}
            <select className="selectStatusPesquisa"
              name="SelectStatusRegistro"
              defaultValue={sessionStorage.selectStatusMensalidade && sessionStorage.selectStatusMensalidade !== undefined ? sessionStorage.selectStatusMensalidade : '99'}
              onChange={event => {
                  sessionStorage.selectStatusMensalidade = event.target.value;
                  setSelectStatus(sessionStorage.selectStatusMensalidade);
              }}
              >
              <option value={'99'} selected={sessionStorage.selectStatusMensalidade && sessionStorage.selectStatusMensalidade === '99'} >TODOS</option>
              <option value={'1'} selected={sessionStorage.selectStatusMensalidade && sessionStorage.selectStatusMensalidade === '1'} >PAGOS</option>
              <option value={'0'} selected={sessionStorage.selectStatusMensalidade && sessionStorage.selectStatusMensalidade === '0'} >PENDENTES</option>
            </select>

              {/* <Link to={`/MapaAnual/${usuario.IdPessoa}`}>  */}
                  <button className="buttonModalPadrao" onClick={() => navigate(`/MapaAnual/${usuario.IdPessoa}`)}>
                      MAPA ANUAL
                  </button>
              {/* </Link> */}

          </div>
        </div>

        {/* Tabela de lancamentos */}
        <div className='tabelaPadrao'>
          <table className='tabelaDados'>
            <thead>
              <tr>
                {/* <th className='tdAlignCenter'>Código</th> */}
                <th className='tdAlignCenter'>Mês</th>
                <th className='tdAlignCenter'>Valor</th>
                <th className='tdAlignCenter'>Posição</th>
                <th className='tdAlignCenter'>Recibo</th>
                <th style={{ textAlign: 'left' }}>Observações</th>
              </tr>
            </thead>
            <tbody>
              { isLoadingMOD ? (
                <tr>
                  <td colSpan="6" style={{ width: "100%", textAlign: "center"}}>
                    <CircularProgress />
                  </td> 
                </tr>
              ) : (
                mensalidades
                .filter((mensalidade) => {
                  if (searchTerm === '') {
                    if (selectStatus === undefined || selectStatus === '' || selectStatus === '99') {
                      return mensalidade;
                    } else if (selectStatus === '1' && parseInt(mensalidade.mslStatus) === 1) {
                      return mensalidade;
                    } else if (selectStatus === '0' && parseInt(mensalidade.mslStatus) === 0) {
                      return mensalidade;
                    }
                  } else {
                    if (selectStatus === undefined || selectStatus === '' || selectStatus === '99') {
                      return mensalidade.mslMesAno.toLowerCase()
                      .includes(searchTerm.toLowerCase());
                    } else if (selectStatus === '1' && parseInt(mensalidade.mslStatus) === 1) {
                      return mensalidade.mslMesAno.toLowerCase()
                      .includes(searchTerm.toLowerCase());
                    } else if (selectStatus === '0' && parseInt(mensalidade.mslStatus) === 0) {
                      return mensalidade.mslMesAno.toLowerCase()
                      .includes(searchTerm.toLowerCase());
                    }
                  } 
                })
                .map((mensalidade) => (
                  <tr key={mensalidade.mslMes}>
                    {/* <td className='tdAlignCenter'>{mensalidade.IdMensalidade}</td> */}
                    <td className='tdAlignCenter'>{handleRetornaMes(mensalidade.mslMes)}</td>
                    <td className='tdAlignCenter'>R$ {mensalidade.mslValor}</td>
                    <td className='tdAlignCenter' style={{ color: parseInt(mensalidade.mslStatus) === 1 ? 'green' : 'red' }}>{parseInt(mensalidade.mslStatus) === 1 ? <ThumbUpAlt style={{ color: 'green' }} /> : <ThumbDownOffAlt style={{ color: 'red' }} />}</td>
                     
                      {(parseInt(mensalidade.mslStatus) === 1 || parseInt(mensalidade.mslStatus) === 0)
                      && mensalidade.mslRecibo === '' ? (
                        <td className='tdAlignCenter'
                        onClick={() => handleEnviarRecibo(mensalidade)}>
                          <button className="buttonGridPadrao3" >
                              Enviar
                          </button>
                        </td>
                      ) : 
                      (
                        <td className='tdAlignCenter'>
                          <button className="buttonGridPadrao" style={{margin: '5px'}}
                            onClick={() => handleExibirRecibo(mensalidade)}>
                              Exibir
                          </button>
                          <button className="buttonGridPadrao3" 
                            onClick={() => handleEnviarRecibo(mensalidade)}>
                              Reenviar
                          </button>
                        </td>
                      )}
                    
                    
                    <td>
                      {(
                          parseInt(mensalidade.mslStatus) === 1 
                          ? 'Pagamento confirmado' 
                          : parseInt(mensalidade.mslStatus) === 0 
                          && mensalidade.mslRecibo !== '' 
                          ? 'Aguardando confirmação' 
                          : 
                          mensalidade.mslObservacoes
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {isLoadingMOD && <p>Carregando...</p>}
        </div>
      </main>
    </div>
    );
}

export default AreaDoAssociado;